// extracted by mini-css-extract-plugin
module.exports = {"tomorrowsFocus":"style_tomorrowsFocus__Ze3GH","loadingSpinner":"style_loadingSpinner__IA2qc","focusSection":"style_focusSection__3quK2"};